import CoursewareTargetProvider from '../CoursewareTargetService';

const targetProvider = CoursewareTargetProvider.build();

export default async function expandSimplifiedTarget(simplifiedTarget) {
  const simplifiedAncestry = simplifiedTarget.simplifiedAncestry || [];

  if (!simplifiedTarget.id) {
    return simplifiedTarget;
  }

  // Fetch the parents first (ordered by activity > interactive > component) so we
  // have everything we need (types and ancestry) before finding the final target.
  if (simplifiedAncestry[0]) {
    await targetProvider.createTarget(simplifiedAncestry[0]);
  }
  if (simplifiedAncestry[1]) {
    await targetProvider.createTarget(simplifiedAncestry[1]);
  }

  const target = await targetProvider.createTarget(simplifiedTarget.id);

  return {
    ...target,
    subTarget: simplifiedTarget.subTarget,
  };
}
